/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_TEXT } from '../../../styles/colors/colors';
export var StyledSearchAndFilter = styled('div')({
  '&.EmbersSearchAndFilter-root': {
    marginBottom: 16,
    borderBottom: "1px solid ".concat(PROMETHEAN_NEUTRAL_DARK_GREY),
    paddingBottom: 15,
    '.EmbersSearchAndFilter-content': {
      display: 'flex',
      columnGap: 16,
      alignItems: 'start',
      '.EmbersSearch-root': {
        flexGrow: 1
      },
      '.hidden': {
        display: 'none'
      }
    }
  },
  '&.EmbersMobileSearchAndFilter-root': {
    paddingBottom: 15,
    '.EmbersSearchAndFilter-content-searchAndFilter': {
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'flex-start',
      columnGap: 8,
      '.EmbersSearch-root': {
        flexGrow: 1
      }
    }
  }
});
export var SearchOrFilterIcon = styled('div')(function () {
  return {
    width: 24,
    height: 24,
    color: PROMETHEAN_TEXT,
    marginTop: 4
  };
});